import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommunicationsService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '@app/_services/authentication.service';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { IconComponent } from '../../../../../../shared/components/icon/icon.component';
import { FlexModule } from '@angular/flex-layout/flex';


@Component({
    selector: 'app-message-information',
    templateUrl: './message-information.component.html',
    styleUrls: ['./message-information.component.scss'],
    providers: [FormDataHelper, TranslateHelper],
    standalone: true,
    imports: [FlexModule, IconComponent, NgFor, NgIf, FormsModule, ReactiveFormsModule, MatButtonModule, MatIconModule, DatePipe, TranslateModule]
})
export class MessageInformationComponent implements OnInit {
    userId: any;

    constructor(public bsModalRef: BsModalRef,
        private fb: UntypedFormBuilder,
        private communicationService: CommunicationsService,
        private toastr: ToastrService,
        private auth: AuthenticationService,
        private fd: FormDataHelper,
        public translate: TranslateService,
        public translateHelper: TranslateHelper) { }
    communicationId;
    messages: any;
    companyData;
    files: any[] = [];
    file: any;
    url;
    form = this.fb.group({
        msg: [null, [Validators.required]],
        images: []
    })
    ngOnInit(): void {
        this.communicationService.getCommunication(this.communicationId).subscribe((response: any) => {
            this.messages = response.data.messages
        });
    }

    send() {
        if (this.form.invalid) {
            this.toastr.error('Fill In Required Fields');
            return;
        }
        let message = new FormData();
        message = this.fd.ToFormData(this.form.value);
        this.communicationService.sendMessage(this.communicationId, message).subscribe((success: any) => {
            if (success) this.bsModalRef.hide();
            this.toastr.success('Message Sent');
        });
    }

    fileBrowseHandler(files) {
        this.prepareFilesList(files);
    }

    prepareFilesList(files: Array<any>) {
        for (const item of files) {
            this.url = null;
            const reader = new FileReader();
            reader.onload = () => {
                item.url = reader.result as string;
            }
            reader.readAsDataURL(item)
            this.files.push(item);
        }
        this.images.patchValue(Array.from(files));
    }

    deletePicture(index) {
        this.files.splice(index, 1);
        this.images.patchValue(this.files);
    }

    get images() {
        return this.form.get('images');
    }
}
